import { isPlatformBrowser } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { PLATFORM_ID, inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { NotificationModalServiceService } from './shared/services/notification-modal-service.service';

export const chunkErrorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const showMessage = inject(NotificationModalServiceService).showMessage;
  return next(req).pipe(
    catchError((error) => {
      const chunkFailedMessage = /Loading chunk [\d]+ failed/;

      if (
        (chunkFailedMessage.test(error.message) ||
          error.message?.includes(
            'Failed to fetch dynamically imported module'
          )) &&
        isPlatformBrowser(platformId)
      ) {
        if (window.location.href.includes('?reload=true')) {
          console.error('Reload failed to load chunk');
          showMessage({
            title: 'Uh oh! Something went wrong',
            message: 'We were unable to load the page. Please try again.',
          });
        } else {
          window.location.href = window.location.href + '?reload=true';
        }
      }

      return throwError(() => error);
    })
  );
};
